export const checkIsFollowed = (
  followings: { preferredUsername: string }[] | undefined,
  targetPreferredUsername: string | undefined,
) =>
  targetPreferredUsername
    ? followings?.some(
        ({ preferredUsername }) =>
          preferredUsername.toLowerCase() === targetPreferredUsername.toLowerCase(),
      ) || false
    : false
